import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    assets: [],
    previews: {}
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.CLEAR_CONTENT_BUILDER_SEARCH:
      return {
        isLoading: false,
        error: null,
        data: {
          assets: [],
          previews: {
            ...state.data.previews
          }
        }
      };
    case Constants.REQUEST_CONTENT_BUILDER_SEARCH:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_CONTENT_BUILDER_SEARCH:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          assets: [...(action.data.items || [])]
        }
      };
    case Constants.REQUEST_CONTENT_BUILDER_PREVIEW:
      return {
        ...state,
        data: {
          ...state.data,
          previews: {
            ...state.data.previews,
            [action.id]: {
              isLoading: true
            }
          }
        }
      };
    case Constants.RECEIVE_CONTENT_BUILDER_PREVIEW:
      if (action.error) {
        return {
          ...state,
          data: {
            ...state.data,
            previews: {
              ...state.data.previews,
              [action.id]: {
                error: action.error,
                isLoading: false
              }
            }
          },
          error: action.error
        };
      }
      const dataUri = `data:image/${action.data.file_ext};base64,${
        action.data.image_url
      }`;

      return {
        ...state,
        data: {
          ...state.data,
          previews: {
            ...state.data.previews,
            [action.id]: {
              isLoading: false,
              dataUri
            }
          }
        }
      };
    default:
      return state;
  }
}
